import {NAVIGATION_REGIONS} from "@pg-rp/navigation";

// The navigation lists the main cities of every voivodeship by their region slug ("suffix").
const VOIVODESHIP_BY_CITY_SLUG: ReadonlyMap<string, string> = new Map(
    NAVIGATION_REGIONS.flatMap((voivodeship) =>
        [...voivodeship.cities_flats, ...voivodeship.cities_houses].map((city) => [city.suffix, voivodeship.name] as const)
    )
);

/** "krakow" → "małopolskie" (lower case, as in "Miasto · małopolskie"); null for a city the navigation does not list. */
export const getVoivodeshipByCitySlug = (citySlug: string): string | null => VOIVODESHIP_BY_CITY_SLUG.get(citySlug) ?? null;
import {NAVIGATION_REGIONS} from "@pg-rp/navigation";

// The navigation lists the main cities of every voivodeship by their region slug ("suffix").
const VOIVODESHIP_BY_CITY_SLUG: ReadonlyMap<string, string> = new Map(
    NAVIGATION_REGIONS.flatMap((voivodeship) =>
        [...voivodeship.cities_flats, ...voivodeship.cities_houses].map((city) => [city.suffix, voivodeship.name] as const)
    )
);

/** "krakow" → "małopolskie" (lower case, as in "Miasto · małopolskie"); null for a city the navigation does not list. */
export const getVoivodeshipByCitySlug = (citySlug: string): string | null => VOIVODESHIP_BY_CITY_SLUG.get(citySlug) ?? null;
